import { styled } from "styled-components";
import React, { useState } from "react";
import { GHallwaySceneCSS } from "../../webl/scenes/payne/hallway/hallwayCSS";
import { RCombinerPass } from "../../webl/postprocess";
import { PayneSceneHallway } from "../../webl/scenes/payne/hallway/hallwayMain";
import { GLightSwitchSceneCSS } from "../../webl/scenes/payne/lightSwitch/lightSwitchScripts";
import { PayneSceneDestrPainting } from "../../webl/scenes/payne/destrPaintingMain/destrPaintingMain";
import { GAudioEngine } from "../../webl/core/audioEngine";
import { GSettings } from "../../webl/core/settings";

const StartScreenWrapMain = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    //background-color: rgba(233, 15, 15, 0.815);
`;

const SubtitleTextStyle = styled.span`
    color: #bebebe;
    font-family: Rubik;
    font-size: clamp(25px, 1vw, 50px);
    //font-size: 30px;
    font-style: normal;
    font-weight: 800;
    text-align: center;

    margin: 15vh;

    width: 75vw;

    z-index: 99;
`;

const SubtitleTextStyleEndQuote = styled(SubtitleTextStyle)`
    background-color: #161616ab;
    width: auto;
    height: auto;
    line-height: clamp(40px, 1vw, 80px);
`;

const SubtitleTextStyleTVScreen = styled(SubtitleTextStyle)`
    font-size: clamp(25px, 2vw, 500px);
`;

const SubtitleTextStyleItalic = styled(SubtitleTextStyle)`
    font-style: italic;
`;

const SubtitleTextStylePrint = styled.span`
    color: #bebebe;
    font-family: SpecialElite;
    font-size: clamp(25px, 1vw, 50px);
    //font-size: 30px;
    font-style: normal;
    text-align: center;

    margin: 7vh;
    color: #0b0806;
    width: auto;
    height: auto;
    line-height: clamp(40px, 2.5vw, 100px);
    //background-color: #9a907b;
    background-color: #91978b;

    z-index: 99;
`;
interface FullscreenTitleProps {
    isVisible: boolean;
    quoteIndex: number;
}

const namesArr = [
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#9CB99E" }}>THE OCEAN: </span> We all get hurt by love...
        </SubtitleTextStyle>
    ),
    //
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#9CB99E" }}>THE OCEAN: </span>And we all have our cross to bear...
        </SubtitleTextStyle>
    ),
    //
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#9CB99E" }}>THE OCEAN: </span>But in the name of understanding now
        </SubtitleTextStyle>
    ),
    //
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#9CB99E" }}>THE OCEAN: </span>Our problems should be shared.
        </SubtitleTextStyle>
    ),
    //
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#9CB99E" }}>THE OCEAN: </span>Confide in me...
        </SubtitleTextStyle>
    ),
];

const SubtitlesOcean: React.FC<FullscreenTitleProps> = ({ isVisible, quoteIndex }) => {
    if (!isVisible) return null;

    // Ensure `quoteIndex` is within the bounds of `namesArr`
    const safeIndex = Math.max(0, Math.min(quoteIndex, namesArr.length - 1));

    return <>{namesArr[safeIndex]()}</>;
};

const oldQuotesArr = [
    () => (
        <SubtitleTextStyleItalic>
            <span style={{ color: "#9CB99E", fontStyle: "normal" }}>THE CIRCLE: </span> Ekki hver maður er óvinur sínum,
            heldur draugr eigin sorgar.
        </SubtitleTextStyleItalic>
    ),
    () => (
        <SubtitleTextStyleItalic>
            <span style={{ color: "#9CB99E", fontStyle: "normal" }}>THE CIRCLE: </span> Sjá inn í hjarta þitt, því
            aðeins sorgarlausir megi Valhöll ná.
        </SubtitleTextStyleItalic>
    ),
];

const NorseSubtitlesOcean: React.FC<FullscreenTitleProps> = ({ isVisible, quoteIndex }) => {
    if (!isVisible) return null;

    // Ensure `quoteIndex` is within the bounds of `namesArr`
    const safeIndex = Math.max(0, Math.min(quoteIndex, oldQuotesArr.length - 1));

    return <>{oldQuotesArr[safeIndex]()}</>;
};

const LowerLowerSubsWrap = styled.div`
    width: 100vw;
    height: 80vh;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    margin-top: 36vh;
    position: absolute;
`;

const QuestionMesnuWrap = styled.div`
    width: 100vw;
    height: 50vh;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    margin-top: 10vh;
    //background-color: rgba(233, 15, 15, 0.815);
`;

const QuestionTextStyle = styled.span`
    color: #98a997;
    font-family: Khand;
    font-size: clamp(110px, 2vw, 200px);
    font-style: normal;
    font-weight: 700;
    text-align: center;

    width: 45vw;

    z-index: 99;

    -webkit-text-stroke: 1px rgba(167, 167, 167, 0.5);
`;

const CenterWrapper = styled.div`
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    height: 100vh; /* Adjust height as needed */
`;

const GuiltTextStyle = styled.span`
    color: #350e0e;
    font-family: Khand;
    font-size: clamp(300px, 10vw, 600px);
    font-style: normal;
    font-weight: 600;
    text-align: center;

    width: 65vw;

    z-index: 99;
`;

export const QuestionTextButtonStyle = styled(QuestionTextStyle)`
    color: #9cb99e;
    font-weight: 400;
    font-size: clamp(35px, 0.5vw, 60px);
    &:hover {
        color: #bebebe;
        font-weight: 500;
    }
`;

const QuestionButtonStyled = styled.button`
    color: #fff;

    width: 40%;
    height: 13%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    //border: 1px solid #fff;
    background-color: rgba(0.1, 0, 0, 0);
`;

interface QuestionMenuProps {
    isQuestonMenuVisible: boolean;
    isSecondQuestionVisible: boolean;
    toggleSecondQuestionVisible: (b: boolean) => void; // Function to toggle isSecondQuestionVisible
    toggleMainVisibility: (b: boolean) => void; // Function to toggle bVisibilityMain
    setGuiltTextVis: (b: boolean) => void; // Function to toggle bVisibilityMain
}

const QuestionSign: React.FC<{ isVisible: boolean; showQuestion: boolean }> = ({ isVisible, showQuestion }) => {
    if (!isVisible) return null;

    return <QuestionTextStyle>{showQuestion ? "?" : "!"}</QuestionTextStyle>;
};

const QuestionOption1: React.FC<{ isQuestonMenuVisible: boolean; toggleMainVisibility: (b: boolean) => void }> = ({
    isQuestonMenuVisible,
    toggleMainVisibility,
}) => {
    if (!isQuestonMenuVisible) return null;
    return (
        <QuestionButtonStyled
            onClick={() => {
                PayneSceneHallway.GInstance!.bPyramidTwistEnabled = true;
                PayneSceneHallway.GInstance!.EHallwaySceneState = 2;
                PayneSceneHallway.GInstance!.PlayPyramidSound();
                toggleMainVisibility(false);
            }}
            onMouseEnter={() => {
                PayneSceneHallway.GInstance!.PlaySelectUISound();
            }}
        >
            <QuestionTextButtonStyle>Succumb to the call, just one last taste.</QuestionTextButtonStyle>
        </QuestionButtonStyled>
    );
};

const QuestionOption2: React.FC<QuestionMenuProps> = ({
    isQuestonMenuVisible,
    isSecondQuestionVisible,
    toggleSecondQuestionVisible,
    toggleMainVisibility,
    setGuiltTextVis,
}) => {
    if (!isSecondQuestionVisible || !isQuestonMenuVisible) return null;
    return (
        <QuestionButtonStyled
            onClick={() => {
                toggleSecondQuestionVisible(false);
                toggleMainVisibility(false);
                RCombinerPass.EFullscreenVFXMode = 1;
                setGuiltTextVis(true);
                PayneSceneHallway.GInstance!.SoundOnGuiltOn();
                setTimeout(() => {
                    toggleMainVisibility(true);
                    setGuiltTextVis(false);
                    RCombinerPass.EFullscreenVFXMode = 0;
                    PayneSceneHallway.GInstance!.SoundOnGuiltOff();
                }, 0.5 * 1000);
            }}
            onMouseEnter={() => {
                PayneSceneHallway.GInstance!.PlaySelectUISound();
            }}
        >
            <QuestionTextButtonStyle>The darkness can wait, it won’t claim me tonight.</QuestionTextButtonStyle>
        </QuestionButtonStyled>
    );
};

const GetQuestionMenu: React.FC<QuestionMenuProps> = ({
    isQuestonMenuVisible,
    isSecondQuestionVisible,
    toggleSecondQuestionVisible,
    toggleMainVisibility,
    setGuiltTextVis,
}) => {
    return (
        <QuestionMesnuWrap>
            <QuestionSign isVisible={isQuestonMenuVisible} showQuestion={isSecondQuestionVisible} />
            <QuestionOption2
                isQuestonMenuVisible={isQuestonMenuVisible}
                isSecondQuestionVisible={isSecondQuestionVisible}
                toggleSecondQuestionVisible={toggleSecondQuestionVisible}
                toggleMainVisibility={toggleMainVisibility}
                setGuiltTextVis={setGuiltTextVis}
            />
            <QuestionOption1 isQuestonMenuVisible={isQuestonMenuVisible} toggleMainVisibility={toggleMainVisibility} />
        </QuestionMesnuWrap>
    );
};

const StartButtonStyled = styled.button`
    color: #98a997;

    font-family: Rubik;
    font-size: clamp(20px, 1.5vw, 200px);
    font-style: normal;
    font-weight: 800;
    text-align: center;

    -webkit-text-stroke: 1px rgba(167, 167, 167, 0.5);

    width: 10vw;
    height: 9vh;
    border: 2px solid #98a997;
    background-color: rgba(0.1, 0.1, 0.1, 0);

    //position: absolute;

    letter-spacing: 1px;

    /* bottom: 40vh;
    left: 50vw;
    transform: translateX(-50%); */

    &:hover {
        background-color: #bebebe;
        color: #252924;
    }

    z-index: 99;
`;

const IntroTextStyle = styled.span`
    color: #98a997;
    color: #bebebeda;
    font-family: Rubik;
    font-size: clamp(20px, 1.5vw, 60px);
    //font-size: 30px;
    font-style: normal;
    font-weight: 500;
    text-align: center;

    /* letter-spacing: 0px; */

    margin: 3.5vh;
    margin-top: 2vh;

    width: 50vw;

    z-index: 99;
`;

const IntroTextStyleError = styled.span`
    color: #98a997;
    font-family: Rubik;
    font-size: clamp(10px, 1.5vw, 60px);
    //font-size: 30px;
    font-style: normal;
    font-weight: 500;
    text-align: center;

    /* letter-spacing: 0px; */

    margin: 3.5vh;
    margin-top: 50vh;

    width: 80vw;

    z-index: 99;
`;

const IntroTextTitle = styled(IntroTextStyle)`
    color: #98a997;
    font-size: clamp(20px, 1.85vw, 60px);
    font-weight: 600;
    margin: 0;
    margin-top: 30vh;
`;

const FullscreenTitle: React.FC = () => {
    return (
        <IntroTextStyle>
            HI, I'M{" "}
            <a href="https://x.com/ohnoweknow" target="_blank" rel="noopener noreferrer" style={{ color: "#98a997" }}>
                internetNobody
            </a>
            , AND THIS INTERACTIVE DEMOSCENE IS MERELY A TRIBUTE TO THE AMAZING{" "}
            <a
                href="https://www.remedygames.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#98a997" }}
            >
                REMEDY ENTERTAINMENT
            </a>
            . <br /> MAKE SURE BROWSER HARDWARE ACCELERATION IS ENABLED.
        </IntroTextStyle>
    );
};

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px; /* Spacing between text and checkbox */
    padding: 8px 12px; /* Add some padding for the container */

    color: #bebebeda;

    margin: 3.5vh;
    margin-bottom: 0;

    width: fit-content; /* Only take as much space as needed */

    z-index: 99;
`;

export const LabelText = styled.span`
    font-family: Rubik;
    font-size: 24px;
    font-weight: 500;
    color: #a0a0a0d1;
`;

export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
    width: 24px;
    height: 24px;
    cursor: pointer;
    appearance: none; /* Remove the default checkbox style */
    background-color: rgba(100, 100, 100, 0.25); /* Semi-transparent when unchecked */
    border: 2px solid rgba(100, 100, 100, 0.25); /* Border for the checkbox */
    border-radius: 1px; /* Optional: rounded corners */

    /* Hover state */
    &:hover {
        border-color: #98a997; /* Green border on hover */
    }

    /* Checked state */
    &:checked {
        background-color: #98a997; /* Green background when checked */
        border-color: #98a997; /* Green border when checked */
        position: relative;
    }

    /* Custom checkmark */
    &:checked::after {
        content: "✔"; /* Unicode checkmark */
        color: white; /* Green checkmark when checked */
        font-size: 14px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const QualityButtonsContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    height: 32px;

    border-radius: 2px;
    background-color: rgba(100, 100, 100, 0.25); /* Semi-transparent when unchecked */
    border: 2px solid rgba(100, 100, 100, 0.25); /* Border for the checkbox */

    z-index: 99;
`;

export const QualityIconContainer = styled.div<{ $isSelected: boolean }>`
    font-family: Rubik;
    align-items: center;
    display: flex;
    justify-content: center;
    width: 48px;
    height: 48px;

    color: ${({ $isSelected }) => ($isSelected ? "#98a997" : "#bebebe")};
    font-weight: ${({ $isSelected }) => ($isSelected ? "600" : "normal")};

    cursor: pointer;

    &:hover {
        //color: #98a997; /* Green background when hovered */
        font-weight: 600;
    }
`;

export const Divider = styled.div`
    display: inline-flex;
    align-items: center;
    height: 28px;
    width: 2px;

    background-color: rgba(100, 100, 100, 0.25); /* Semi-transparent when unchecked */
`;

export const QualityContainer = styled(CheckboxContainer)`
    &:hover .fps-overlay {
        visibility: visible;
        opacity: 1;
    }
`;

export const FPSOverlay = styled.div<{ $fpsColor: string }>`
    font-family: Rubik;
    font-size: 24px;
    font-weight: 500;
    color: ${({ $fpsColor }) => $fpsColor};
    //visibility: hidden;
    /* opacity: 0;
    transition: opacity 0.3s; */
`;

export const QualitySelector: React.FC = () => {
    const [quality, setQuality] = useState<number>(GSettings.EQuality);
    const [isFpsVisible, setFpsVisible] = useState<boolean>(false);
    const [fps, setFps] = useState<number>(60);

    GHallwaySceneCSS.setCurFps = setFps;

    const getFpsColor = (inFps: number): string => {
        if (inFps < 35) return "red";
        if (inFps < 50) return "yellow";
        return "green";
    };

    const handleQualityChange = (newQuality: number) => {
        if (quality !== newQuality) {
            GSettings.EQuality = newQuality;
            GSettings.bQualityChangeThisFrame = true;
            setQuality(newQuality);
            GHallwaySceneCSS.setQualityFooter(newQuality);
        }
    };

    return (
        <>
            <QualityContainer onMouseEnter={() => setFpsVisible(true)}>
                <LabelText>QUALITY</LabelText>
                <QualityButtonsContainer>
                    <QualityIconContainer $isSelected={quality === 0} onClick={() => handleQualityChange(0)}>
                        LQ
                    </QualityIconContainer>
                    <Divider />
                    <QualityIconContainer $isSelected={quality === 1} onClick={() => handleQualityChange(1)}>
                        MQ
                    </QualityIconContainer>
                    <Divider />
                    <QualityIconContainer $isSelected={quality === 2} onClick={() => handleQualityChange(2)}>
                        HQ
                    </QualityIconContainer>
                </QualityButtonsContainer>
            </QualityContainer>
            <CheckboxContainer>
                {isFpsVisible && (
                    <FPSOverlay className="fps-overlay" $fpsColor={getFpsColor(fps)}>
                        {fps} FPS
                    </FPSOverlay>
                )}
            </CheckboxContainer>
        </>
    );
};

export const GetStartScreen: React.FC = () => {
    const [bVisibilityMain, setButtonVis] = useState<boolean>(false);
    GHallwaySceneCSS.setStartButtonVis = setButtonVis;

    const [bDeviceSupport, setDeviceSupport] = useState<boolean>(true);
    GHallwaySceneCSS.setDeviceSupport = setDeviceSupport;

    const [isSoundEnabled, setSoundEnabled] = useState(GAudioEngine.isSoundEnabled);
    GAudioEngine.setSoundEnabled = setSoundEnabled;

    const toggleCheckbox = () => {
        GAudioEngine.Instance.toggleSound();
    };

    if (!bVisibilityMain) {
        return null;
    } else {
        if (bDeviceSupport) {
            return (
                <StartScreenWrapMain>
                    <IntroTextTitle>DEAREST</IntroTextTitle>

                    <FullscreenTitle />

                    <StartButtonStyled
                        onClick={() => {
                            PayneSceneHallway.GInstance!.EHallwaySceneState = 0;
                            PayneSceneHallway.GInstance!.PlayOceanSong();
                            setButtonVis(false);
                            GHallwaySceneCSS.setVisibilityMain(true);
                        }}
                        onMouseEnter={() => {
                            PayneSceneHallway.GInstance!.PlaySelectUISound();
                        }}
                    >
                        PLAY
                    </StartButtonStyled>

                    <CheckboxContainer>
                        <LabelText>AUDIO</LabelText>
                        <StyledCheckbox checked={isSoundEnabled} onChange={toggleCheckbox} />
                    </CheckboxContainer>

                    <QualitySelector></QualitySelector>
                </StartScreenWrapMain>
            );
        } else {
            return (
                <StartScreenWrapMain>
                    <IntroTextStyleError>Mobile devices still in dev, please use PC instead.</IntroTextStyleError>
                </StartScreenWrapMain>
            );
        }
    }
};

export const IntroTextWrapper: React.FC = () => {
    const [bVisibilityMain, setVisibilityMain] = useState<boolean>(false);

    const [isSubtitleVisible, subtitleTextSetVisible] = useState<boolean>(false);

    const [isQuestionVisible, questionTextSetVisible] = useState<boolean>(false);

    const [bGuiltTextShown, setGuiltTextVis] = useState<boolean>(false);

    const [isSecondQuestionVisible, setSecondQuestVisiblity] = useState<boolean>(true);

    const [quoteIndex, setQuoteIndex] = useState<number>(0);
    const [guiltQuoteIndex, setGuiltQuoteIndex] = useState<number>(0);

    GHallwaySceneCSS.setVisibilityMain = setVisibilityMain;
    GHallwaySceneCSS.subtitleTextSetVisible = subtitleTextSetVisible;
    GHallwaySceneCSS.setOceanSubQuoteIndex = setQuoteIndex;
    GHallwaySceneCSS.guiltTextQuoteIndex = setGuiltQuoteIndex;
    GHallwaySceneCSS.questionTextSetVisible = questionTextSetVisible;
    GHallwaySceneCSS.guiltTextSetVisible = setGuiltTextVis;

    if (!bVisibilityMain) {
        if (bGuiltTextShown) {
            if (guiltQuoteIndex == 0) {
                return (
                    <CenterWrapper>
                        <GuiltTextStyle>STAY.</GuiltTextStyle>
                    </CenterWrapper>
                );
            } else {
                return (
                    <CenterWrapper>
                        <GuiltTextStyle>
                            {" "}
                            <span style={{ color: "#444444" }}>NICE TRY. </span>{" "}
                        </GuiltTextStyle>
                    </CenterWrapper>
                );
            }
        } else {
            return null;
        }
    } else {
        return (
            <StartScreenWrapMain>
                <SubtitlesOcean isVisible={isSubtitleVisible} quoteIndex={quoteIndex} />
                <GetQuestionMenu
                    isQuestonMenuVisible={isQuestionVisible}
                    isSecondQuestionVisible={isSecondQuestionVisible}
                    toggleSecondQuestionVisible={setSecondQuestVisiblity}
                    toggleMainVisibility={setVisibilityMain}
                    setGuiltTextVis={setGuiltTextVis}
                />
            </StartScreenWrapMain>
        );
    }
};

export const NorseSubs: React.FC = () => {
    const [bVisibilityMain, setNorseSubVis] = useState<boolean>(false);
    const [bTVVis, setTVSubVis] = useState<boolean>(false);

    const [quoteIndex, setNorseQuoteIndex] = useState<number>(0);

    GHallwaySceneCSS.setTVSubVisibility = setTVSubVis;
    GHallwaySceneCSS.setNorseSubVisibility = setNorseSubVis;
    GHallwaySceneCSS.setNorseSubQuoteIndex = setNorseQuoteIndex;

    if (bTVVis) {
        return (
            <CenterWrapper>
                <SubtitleTextStyleTVScreen>
                    <span style={{ color: "#350e0e" }}>What's on the TV tonight? </span>
                    {/* <span style={{ color: "#350e0e" }}>WHAT DO YOU SEE? </span> */}
                    {/* <span style={{ color: "#350e0e" }}>COME DOWN TO US </span> */}
                </SubtitleTextStyleTVScreen>
            </CenterWrapper>
        );
    }
    if (!bVisibilityMain) {
        return null;
    } else {
        return (
            <LowerLowerSubsWrap>
                <NorseSubtitlesOcean isVisible={bVisibilityMain} quoteIndex={quoteIndex} />
            </LowerLowerSubsWrap>
        );
    }
};

const lightSwitchQuotesArr = [
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#B9162B", fontStyle: "normal" }}>AI46-KE: </span> The rule of five applies here.
        </SubtitleTextStyle>
    ),
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#B9162B", fontStyle: "normal" }}>AI46-KE: </span> Everyone.
        </SubtitleTextStyle>
    ),
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#B9162B", fontStyle: "normal" }}>AI46-KE: </span> Everyone. You.
        </SubtitleTextStyle>
    ),
    () => (
        <SubtitleTextStyle>
            <span style={{ color: "#B9162B", fontStyle: "normal" }}>AI46-KE: </span> Everyone. You. Touch.
        </SubtitleTextStyle>
    ),
];
const LightswitchSubs: React.FC<FullscreenTitleProps> = ({ isVisible, quoteIndex }) => {
    if (!isVisible) return null;

    // Ensure `quoteIndex` is within the bounds of `namesArr`
    const safeIndex = Math.max(0, Math.min(quoteIndex, lightSwitchQuotesArr.length - 1));

    return <>{lightSwitchQuotesArr[safeIndex]()}</>;
};

export const GetLightswitchsubs: React.FC = () => {
    const [bVisibilityMain, setSubVisibility] = useState<boolean>(false);
    const [bVisibilityDies, setDiesVisibility] = useState<boolean>(false);

    const [quoteIndex, setSubQuoteIndex] = useState<number>(0);

    GLightSwitchSceneCSS.setSubVisibility = setSubVisibility;
    GLightSwitchSceneCSS.setSubQuoteIndex = setSubQuoteIndex;
    GLightSwitchSceneCSS.setDiesVisibility = setDiesVisibility;

    if (bVisibilityDies) {
        return (
            <CenterWrapper>
                <GuiltTextStyle>
                    <span style={{ fontWeight: "700", color: "rgba(19, 19, 19, 0.26)" }}>DIES. </span>
                </GuiltTextStyle>
            </CenterWrapper>
        );
    }
    if (!bVisibilityMain) {
        return null;
    } else {
        return (
            <LowerLowerSubsWrap>
                <LightswitchSubs isVisible={bVisibilityMain} quoteIndex={quoteIndex} />
            </LowerLowerSubsWrap>
        );
    }
};

export const GetResidenceSub: React.FC = () => {
    const [bVisibilityMain, setSubVisibility] = useState<boolean>(false);

    GLightSwitchSceneCSS.setResidenceSubVisibility = setSubVisibility;

    if (!bVisibilityMain) {
        return null;
    } else {
        return (
            <LowerLowerSubsWrap>
                <>
                    <SubtitleTextStyleItalic>
                        {/*  <span style={{ color: "#9CB99E" }}>THE WITCH: </span>IS THIS THE PAIN RESIDENCE? */}
                        <span style={{ color: "#9CB99E", fontStyle: "normal" }}>THE WITCH: </span>Is this the pain
                        residence?
                        {/* Is this the pain residence? */}
                    </SubtitleTextStyleItalic>
                </>
            </LowerLowerSubsWrap>
        );
    }
};

export const MainQuoteText = styled.span`
    color: #8a2829;

    font-family: Khand;
    --custfont-size: clamp(250px, 18vw, 600px);
    font-size: var(--custfont-size);
    letter-spacing: calc(var(--custfont-size) * -0.05);
    font-style: normal;
    font-weight: 700;

    /* margin-right: 13.7vw; */
    margin-bottom: 15vh;

    text-align: center;

    z-index: 99;

    /* margin: 10vh;

    width: 90vw; */
    //height: 50%;
`;

const MainQuoteTextSmall = styled(MainQuoteText)`
    /* --custfont-size: clamp(250px, 18vw, 600px); */
    /* font-size: var(--custfont-size); */
    letter-spacing: calc(var(--custfont-size) * -0.04);
`;

export const GetNicoleFullscreenText: React.FC = () => {
    const [bVisibilityMain, setSubVisibility] = useState<boolean>(false);
    const [bOceanViewVis, setOceanViewVis] = useState<boolean>(false);

    GLightSwitchSceneCSS.setOceanViewTitleSubVisibility = setOceanViewVis;
    PayneSceneDestrPainting.setMainTitleSubVisibility = setSubVisibility;

    if (!bVisibilityMain) {
        if (bOceanViewVis) {
            return (
                <MainQuoteTextSmall>
                    {/* REGR<span style={{ letterSpacing: "calc(var(--custfont-size) * -0.01)" }}>E</span>T */}R
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.05)" }}>E</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.06)" }}>MO</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.03)" }}>R</span>
                    SE
                </MainQuoteTextSmall>
            );
        }
        return null;
    } else {
        return (
            <CenterWrapper>
                <MainQuoteText>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.06)" }}>N</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.06)" }}>I</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.04)" }}>C</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.06)" }}>O</span>
                    <span style={{ letterSpacing: "calc(var(--custfont-size) * -0.025)" }}>L</span>E
                </MainQuoteText>
                {/* <GuiltTextStyle>STAY.</GuiltTextStyle> */}
            </CenterWrapper>
        );
    }
};

// Styled Components
export const HealthbarContainer = styled.div`
    position: absolute;
    width: 691px;
    height: 7vh;
    bottom: 1vh;
    left: 50vw;
    transform: translateX(-50%);
    text-align: start;
    /* background-color: purple; */

    /* display: flex;
    justify-content: center;
    align-items: center; */

    z-index: 99;
`;

export const BossName = styled.div`
    margin-bottom: 2px;
    color: #9cb99e;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
`;

export const HealthBar = styled.div`
    position: relative;
    width: 100%;
    height: 9px;
`;

export const HealthBarBorder = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #261313;
    border: 1px solid #8a2829;
    box-sizing: border-box;
    z-index: 40;
`;

export const HealthBarCurrent = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: #8a2829;
    z-index: 80;
    /* transition: width 0.3s ease; */
`;

export const GetHealthbar: React.FC = () => {
    const [bVisibilityMain, setMainVisibility] = useState<boolean>(false);
    const [health, setHealth] = useState(50); // Initial health set to 100%

    PayneSceneDestrPainting.setHealthbarVisibility = setMainVisibility;
    PayneSceneDestrPainting.setHealthbarCur = setHealth;

    if (!bVisibilityMain) {
        return null;
    } else {
        return (
            <HealthbarContainer>
                <BossName>THE POSTER ON THE WALL</BossName>
                <HealthBar>
                    <HealthBarCurrent style={{ width: `${health}%` }} />
                    <HealthBarBorder />
                </HealthBar>
            </HealthbarContainer>
        );
    }
};

const alanQuoteArr = [
    () => (
        <SubtitleTextStylePrint>
            {" "}
            &nbsp; Direct shots were useless. Her <span style={{ color: "#571213" }}>heart </span> was the key.{" "}
            <span style={{ textDecoration: "underline", color: "#9A907B", textDecorationColor: "#0b0806" }}>Max</span>{" "}
            had to find it. Destroy it. End her. &nbsp;
        </SubtitleTextStylePrint>
    ),
    //
    () => (
        <SubtitleTextStylePrint>
            &nbsp; In the <span style={{ textDecoration: "underline" }}>light</span> , the heart remained hidden.
            Invulnerable. Scared of being exposed. &nbsp;
        </SubtitleTextStylePrint>
    ),
];

export const GetAlanSub: React.FC = () => {
    const [bVisibilityMain, setSubVisibility] = useState<boolean>(false);
    const [bVisibilityEndQuote, setEndSubVisibility] = useState<boolean>(false);
    const [quoteNum, setQuoteNum] = useState<number>(0);
    const [quoteNum2, setQuoteNum2] = useState<number>(0);

    PayneSceneDestrPainting.setMaxSubVisibility = setEndSubVisibility;
    PayneSceneDestrPainting.setAlanSubVisibility = setSubVisibility;
    PayneSceneDestrPainting.setAlanSubNum = setQuoteNum;
    PayneSceneDestrPainting.setMaxSubNum = setQuoteNum2;

    const safeIndex = Math.max(0, Math.min(quoteNum, alanQuoteArr.length - 1));

    if (!bVisibilityMain) {
        if (bVisibilityEndQuote) {
            if (quoteNum2 == 0) {
                return (
                    <LowerLowerSubsWrap>
                        <>
                            <SubtitleTextStyleEndQuote>
                                <span style={{ color: "#8a2829", fontStyle: "normal" }}>&nbsp; JAMES: </span>I released
                                my finger from the trigger. And then it was all over. &nbsp;
                            </SubtitleTextStyleEndQuote>
                        </>
                    </LowerLowerSubsWrap>
                );
            } else if (quoteNum2 == 1) {
                return (
                    <LowerLowerSubsWrap>
                        <>
                            <SubtitleTextStyleEndQuote>
                                <span style={{ color: "#8a2829", fontStyle: "normal" }}>&nbsp; JAMES: </span>Only
                                silence remained - a calm I couldn’t place, a journey to where no map could follow.
                                &nbsp;
                            </SubtitleTextStyleEndQuote>
                        </>
                    </LowerLowerSubsWrap>
                );
            } else if (quoteNum2 == 2) {
                return (
                    <LowerLowerSubsWrap>
                        <>
                            <SubtitleTextStyleEndQuote>
                                <span style={{ color: "#8a2829", fontStyle: "normal" }}>&nbsp; OOP7-KE: </span>A
                                turned-off TV becomes a mirror. What will you see? &nbsp;
                            </SubtitleTextStyleEndQuote>
                        </>
                    </LowerLowerSubsWrap>
                );
            } else {
                return null;
            }
        }
        return null;
    } else {
        return (
            <StartScreenWrapMain>
                <>{alanQuoteArr[safeIndex]()}</>
            </StartScreenWrapMain>
        );
    }
};

const PageContrainerMain = styled.div`
    margin-top: 7vh;

    color: #0b0806;
    background-color: #b2a290;

    display: flex;
    justify-content: center; /* Centers the text container horizontally */
    align-items: center; /* Centers the text container vertically */

    width: 650px;
    height: 800px;
    font-size: 14px;

    letter-spacing: auto;
    word-spacing: 2px;
`;

const PageContrainerText = styled.span`
    font-family: SpecialElite;
    //font-size: 30px;
    font-style: normal;
    text-align: justify;

    width: 74%;
    height: 100%;
    line-height: 175%;

    white-space: pre-wrap; /* Preserve whitespace and line breaks */
    text-indent: 50px; /* Indent the first line of each paragraph */

    z-index: 110;

    word-wrap: break-word; /* Break words if necessary */
    hyphens: auto; /* Automatically hyphenate words when breaking them */
`;

const pageTextArr = [
    () => (
        <PageContrainerMain>
            <PageContrainerText>
                {`
				
	
	


	The red thread led to the heart of the maze, pulling Max forward, not a guide but a demand — inevitability you couldn’t defy, the monster you are never ready to meet.
	
	And then came the singing. Melodic, yet dissonant, like a lullaby sung by something that had never known sleep. It echoed from the room ahead, harmonizing with the suffocating silence. The ocean waited there, vast and formless, its presence not seen but felt, pressing against the shadows of the room.
	
	“Confide in me...”
	
	He understood the game, he always had. The song was an illusion, a mask to hide the predator beneath. “One last taste,” he thought, the lie whispered as if by someone else.
	
	The air shifted, heavy with an unseen weight. Order began to convulse. Lines warped into a spiraling vortex — a cruel mockery of symmetry. Twisting like a drill burrowing into your skull, turning your eyes onto the inside.
	
	What's on the TV tonight?`}
            </PageContrainerText>
        </PageContrainerMain>
    ),
    () => (
        <PageContrainerMain>
            <PageContrainerText>
                {`
				
	
	

	The Daughter. The Wife. The Lover. The Friend. The Mother.
	
	A room in a forgotten motel, the kind that seemed untouched by reality. A painting on the wall. Its colors bleeding into one another, beckoning him with a soft, cruel familiarity.

	The light cord hung from the ceiling, as if descended from heaven itself. Each pull of the switch, he thought, could bring him to the lives he once had, to the sensations he could almost feel: the silky hair; the firm body; the helping hand.

	But with each pull, the scene would shift. The light would flicker. Room darkening. The image changing. Pulling him deeper into something darker, further from what he desired. Hope had twisted. Now a cycle. Each turn dragging him closer to the truth.

	"Everyone you touch..." — said the cunning Flamingo, holding the final word for the last accord.

	The final pull came. The fifth time. His hand was steady now, resigned to the truth. It wasn’t about what he wanted. The room spun, the edges of the world dissolving into flames.

	The witch was waiting.`}
            </PageContrainerText>
        </PageContrainerMain>
    ),
    () => (
        <PageContrainerMain>
            <PageContrainerText>
                {`
				
	
	

		All joy and no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy
		All joy and no pain mekes Max a dull boy
	     v All joy and no pain mak s Max a dull boy
		All joy and no pain makes Max a dull boy
		All joy and no dont look at them dull boy
		All joy and no pain makes Max a dull boy
		All work and no play makes me a dull boy.
		All joy and no pain makes Max a dull boy
		All play and no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy
		All pain and no gain makes Max a dull boy
		All joy and no pain makes Max a dull boy!
		All my life no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy
		All jjoy and no pai makes Max a dull boy
		All joy and no pain makes Max a dull boy
		all joy and no pain makes Max a dull boy
		 All the flesh and tears of fallen angels
		All work and no pay makes Alan a dull boy
		All jooy and no  ain makes Max a dull boy
		a All joy and no pain makes Max a dull boy
		All joy and no pain makes Max a dull boy`}
            </PageContrainerText>
        </PageContrainerMain>
    ),
    () => (
        <PageContrainerMain>
            <PageContrainerText>
                {`
				
	
	

	Max stood before the painting. The plaque beneath read "The Director". She was the one in control, spinning the threads of his fate, weaving her twisted machiavellian tapestry. But Max saw through it. It wasn’t a painting. It was a poster.

	There’s a hole behind that poster that leads to a real world - one stripped of guilt, beyond pain. He could feel it pulling at him, calling from behind the facade.

	He raised his ingrams and loaded a hundred rounds of lead straight into the witch’s heart. 

	The illusion shattered, unveiling the winter outside. The answer raised from the echoes of the gunshots. Soft, unassuming, a whisper. "It's not your fault." Words that hit harder than the recoil. To forget takes more than strength; it demands surrender  — the kind that sets you free.

	He flew out into the storm, the cold air biting like a reminder he was still alive. The snow didn’t ask questions. The wind didn’t need answers. The destination didn’t matter anymore. The journey is all that was left. `}
            </PageContrainerText>
        </PageContrainerMain>
    ),
    () => (
        <PageContrainerMain>
            <PageContrainerText>
                {`
				
	Thank you for playing this short demoscene!

	Max Payne 1 was one of the first games I ever played, and its opening scene shocked me, still just a small kid, more than any fairytale monster. What an experience!

	Can't imagine how many times I replayed Max Payne 2, each time with a new mod installed.

	I’m in love with the magic realism style of Control and Alan Wake, beautifully expressed through their art direction and narrative design.

	I admire Remedy for their incredible blend of surreal atmosphere and dynamic gameplay, their games ensure you're never left uninterested.

	James McCaffrey is one of the reasons why these games and characters are so deeply cherished. You can't read a Max Payne quote without hearing his voice in your head. James's presence is forever etched into Remedy's universe, allowing us to relive a part of his journey every time we step into their worlds.

	Thank you, Remedy, for your courage, your unique style, and for never being afraid to seem strange, all while exceeding the technical standards of the industry.

	Let your northern light scare away any darkness! `}
            </PageContrainerText>
        </PageContrainerMain>
    ),
];

const StartScreenWrapAbsoluteMain = styled.div`
    width: 50vw;
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* Centers the element */

    z-index: 110;
`;

export const GetPages: React.FC = () => {
    const [bPageOpen, setPageOpen] = useState(GHallwaySceneCSS.bPageOpen);
    const [pageIndex, setPageIndex] = useState(0);

    GHallwaySceneCSS.setPageOpen = setPageOpen;
    GHallwaySceneCSS.setPageIndex = setPageIndex;

    const curpageIndex = Math.max(0, Math.min(pageIndex, pageTextArr.length - 1));

    if (bPageOpen) {
        return (
            <StartScreenWrapAbsoluteMain>
                <>{pageTextArr[curpageIndex]()}</>
            </StartScreenWrapAbsoluteMain>
        );
    }
};
